var allowSubmit = false;
var target = null;

function displayTexts(target) {
  $('#modal-title').text(target.dataset.title);
  $('#modal-body1').text(target.dataset.body1);
  $('#modal-body2').text(target.dataset.body2);
  $('#allow-action-modal').text(target.dataset.confirm);
}

function openConfirmModal() {
  $('#dataConfirm').addClass('is-open');
}

function closeConfirmModal() {
  $('#dataConfirm').removeClass('is-open');
}

document.addEventListener('turbo:load', () => {
  const modal = document.getElementById('dataConfirm');

  if ($('.open-confirm-modal').length) {
    $('.open-confirm-modal').on('click', function(event) {
      if (!allowSubmit) {
        event.preventDefault();
        target = event.currentTarget;
        displayTexts(target);
        $('#modal-buttons').removeClass('d-none');
        openConfirmModal();
        $('#allow-action-modal').on('click', function() {
          allowSubmit = true;
          closeConfirmModal();
          target.click();
        });
      } else {
        allowSubmit = false;
      }
    });
  }

  if (modal) {
    $('.confirm-modal-close').on('click', closeConfirmModal);
    $(modal).on('click', function(event) {
      if (event.target === modal) closeConfirmModal();
    });
  }
});
